<template>
  <div class="edit-container-goods-container">
    <div class="edit-container-goods-container__header">
      <div class="edit-container-goods-container__header-left">
        <span class="edit-container-goods-container__badge">
          {{ detail.containerName || '-' }}
        </span>
        <span
          class="edit-container-goods-container__no"
          :class="{ 'is-empty': !detail.containerNo }"
        >
          {{ detail.containerNo || '-' }}
        </span>
        <span
          v-if="isBooked"
          class="edit-container-goods-container__booked-tag"
        >
          <i class="el-icon-lock" /> {{ $l('label_booked') || '已订舱' }}
        </span>
      </div>
      <div class="edit-container-goods-container__header-right">
        <span class="edit-container-goods-container__sku-count">
          <i class="el-icon-tickets" />
          {{ goodsCount }} SKU
        </span>
        <button
          class="edit-container-goods-container__action"
          :disabled="isBooked"
          :title="$l('btn_edit_container') || '编辑货柜'"
          @click="$emit('edit')"
        >
          <i class="el-icon-edit" />
        </button>
        <button
          class="edit-container-goods-container__action"
          :title="$l('btn_copy_container') || '复制货柜'"
          @click="$emit('copy')"
        >
          <i class="el-icon-copy-document" />
        </button>
        <button
          class="edit-container-goods-container__action is-danger"
          :disabled="isBooked"
          :title="$l('btn_delete_container') || '删除货柜'"
          @click="$emit('delete')"
        >
          <i class="el-icon-delete" />
        </button>
        <el-dropdown
          v-if="!detail.shipmentBookingCode"
          trigger="click"
          size="mini"
          class="d-flex"
          @command="onBookingCommand"
        >
          <button
            class="edit-container-goods-container__action edit-container-goods-container__action--more"
            :title="$l('btn_more') || '更多'"
          >
            <i class="fa fa-ship" />
            <i class="el-icon-arrow-down el-icon--right" />
          </button>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="create-booking">
              {{ $l('btn_create_booking') || '新建订舱' }}
            </el-dropdown-item>
            <el-dropdown-item command="append-booking">
              {{ $l('btn_append_booking') || '追加订舱' }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="edit-container-goods-container__info-bar">
      <span
        v-if="detail.sealNo"
        class="edit-container-goods-container__info-tag"
      >
        <i class="el-icon-lock" /> {{ $l('label_seal_no') || '箱封号：'
        }}<strong>{{ detail.sealNo }}</strong>
      </span>
      <span
        v-if="
          detail.extendParameterType === 'LWH' ||
            detail.extendParameterType === 'VM'
        "
        class="edit-container-goods-container__info-tag"
      >
        <i class="el-icon-set-up" />
        {{ detail.extendParameterTypeName || detail.extendParameterType }}
      </span>
      <span
        v-if="detail.extendParameterType === 'LWH'"
        class="edit-container-goods-container__info-tag"
      >
        {{ $l('label_length') || '长' }}
        {{ fmtNum(detail.extendParameterLength) }} ×
        {{ $l('label_width') || '宽' }}
        {{ fmtNum(detail.extendParameterWidth) }} ×
        {{ $l('label_height') || '高' }}
        {{ fmtNum(detail.extendParameterHeight) }} cm
      </span>
      <span
        v-else-if="detail.extendParameterType === 'VM'"
        class="edit-container-goods-container__info-tag"
      >
        {{ $l('label_assign_volume') || '指定体积：'
        }}<strong>{{ fmtNum(detail.containerBookingVolume) }} m³</strong>
      </span>
    </div>

    <div class="edit-container-goods-container__gauges">
      <div class="edit-container-goods-container__gauge-item">
        <div class="edit-container-goods-container__gauge-header">
          <span class="edit-container-goods-container__gauge-label">
            <i class="el-icon-box" /> {{ $l('label_volume') || '体积' }}
          </span>
          <span
            class="edit-container-goods-container__gauge-used"
            :class="volumeStatus"
          >
            {{ detail.containerVolume || 0 }}
            <span class="edit-container-goods-container__gauge-unit">
              / {{ detail.containerBookingVolume || 0 }} m³
            </span>
          </span>
        </div>
        <div class="edit-container-goods-container__gauge-body">
          <div class="edit-container-goods-container__gauge-track">
            <div
              class="edit-container-goods-container__gauge-fill"
              :class="volumeStatus"
              :style="getGaugeFillStyle(volumePct)"
            />
          </div>
          <div class="edit-container-goods-container__gauge-scale">
            <span
              v-for="mark in gaugeMarks"
              :key="mark"
              class="edit-container-goods-container__gauge-mark"
              :style="{ left: mark + '%' }"
            >
              {{ mark }}%
            </span>
          </div>
        </div>
      </div>

      <div class="edit-container-goods-container__gauge-item">
        <div class="edit-container-goods-container__gauge-header">
          <span class="edit-container-goods-container__gauge-label">
            <i class="el-icon-data-line" /> {{ $l('label_gross_weight') || '毛重' }}
          </span>
          <span
            class="edit-container-goods-container__gauge-used"
            :class="weightStatus"
          >
            {{ detail.containerGrossWeight || 0 }}
            <span class="edit-container-goods-container__gauge-unit">
              / {{ detail.weightLimit || 0 }} kg
            </span>
          </span>
        </div>
        <div class="edit-container-goods-container__gauge-body">
          <div class="edit-container-goods-container__gauge-track">
            <div
              class="edit-container-goods-container__gauge-fill is-weight"
              :class="weightStatus"
              :style="getGaugeFillStyle(weightPct)"
            />
          </div>
          <div class="edit-container-goods-container__gauge-scale">
            <span
              v-for="mark in gaugeMarks"
              :key="mark"
              class="edit-container-goods-container__gauge-mark"
              :style="{ left: mark + '%' }"
            >
              {{ mark }}%
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { round, multiply } from '@/libs/util.number'

export default {
  props: {
    detail: { type: Object, default: () => ({}) },
    isBooked: { type: Boolean, default: false },
  },
  data() {
    return {
      gaugeMarks: [25, 50, 75, 100],
    }
  },
  computed: {
    goodsCount() {
      return (this.detail.listGoods || []).length
    },
    volumePct() {
      return Math.min(
        round(multiply(this.detail.volumeUsageRate || 0, 100), 0),
        100
      )
    },
    weightPct() {
      return Math.min(
        round(multiply(this.detail.weightUsageRate || 0, 100), 0),
        100
      )
    },
    volumeStatus() {
      return this.volumePct >= 100 ? 'over' : this.volumePct >= 80 ? 'high' : ''
    },
    weightStatus() {
      return this.weightPct >= 100 ? 'over' : this.weightPct >= 80 ? 'high' : ''
    },
  },
  methods: {
    fmtNum(val) {
      return val != null ? round(val, 1) : '-'
    },
    onBookingCommand(command) {
      switch (command) {
        case 'create-booking':
          this.$emit('create-booking')
          break
        case 'append-booking':
          this.$emit('append-booking')
          break
        default:
          break
      }
    },
    getGaugeFillStyle(pct) {
      const num = Number(pct || 0)
      if (num <= 0) {
        return { width: '0', minWidth: '0' }
      }
      return {
        width: `${num}%`,
        minWidth: '12px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-container-goods-container {
  padding: 10px 16px 8px;
  background: #fff;
  box-sizing: border-box;
}

.edit-container-goods-container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.edit-container-goods-container__header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.edit-container-goods-container__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  font-size: 11px;
  font-weight: 600;
  background: #f0f7ff;
  color: #409eff;
  border: 1px solid #bfdcff;
  border-radius: 5px;
  padding: 0 8px;
}

.edit-container-goods-container__no {
  font-size: 16px;
  font-weight: 600;
  color: #344054;
  line-height: 20px;
  letter-spacing: 0.02em;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.is-empty {
    font-size: 14px;
    font-weight: 500;
    color: #98a2b3;
  }
}

.edit-container-goods-container__sku-count {
  height: 20px;
  font-size: 11px;
  color: #667085;
  border-radius: 5px;
  padding: 0 2px;
  display: flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
}

.edit-container-goods-container__header-right {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 12px;
}

.edit-container-goods-container__action {
  font-size: 12px;
  height: 20px;
  min-width: 20px;
  padding: 0 5px;
  border: 1px solid #dbe3ef;
  border-radius: 5px;
  background: #fff;
  color: #98a2b3;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 3px;

  &:hover {
    border-color: #409eff;
    color: #409eff;
    background: #f5f9ff;
  }

  &.is-danger:hover {
    border-color: #f56c6c;
    color: #f56c6c;
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.edit-container-goods-container__action--detail {
  height: 24px;
  padding: 0 9px;
  color: #667085;
}

.edit-container-goods-container__info-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.edit-container-goods-container__info-tag {
  min-height: 20px;
  font-size: 10px;
  color: #667085;
  background: #f8fafc;
  border: 1px solid #eaecf0;
  border-radius: 5px;
  padding: 1px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 16px;

  strong {
    color: #344054;
  }
}

.edit-container-goods-container__gauges {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 8px;
  align-items: stretch;
  padding: 2px 0 0;
}

.edit-container-goods-container__gauge-item {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.edit-container-goods-container__gauge-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
  min-height: 18px;
  margin-bottom: 5px;
}

.edit-container-goods-container__gauge-label {
  font-size: 11px;
  color: #667085;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  line-height: 14px;
  white-space: nowrap;
}

.edit-container-goods-container__gauge-used {
  font-size: 11px;
  font-weight: 600;
  color: #409eff;
  margin-left: auto;
  line-height: 14px;
  white-space: nowrap;
  display: inline-flex;
  align-items: baseline;
  gap: 3px;

  &.high {
    color: #e6a23c;
  }

  &.over {
    color: #f56c6c;
  }
}

.edit-container-goods-container__gauge-unit {
  font-size: 10px;
  font-weight: 400;
  color: #98a2b3;
}

.edit-container-goods-container__gauge-body {
  position: relative;
  padding-top: 0;
  padding-bottom: 14px;
}

.edit-container-goods-container__gauge-track {
  position: relative;
  height: 6px;
  background: #edf2f7;
  border-radius: 999px;
  overflow: hidden;
}

.edit-container-goods-container__gauge-fill {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: #4c9dff;
  border-radius: 999px;
  transition: width 0.3s;
  box-shadow: 0 1px 2px rgba(76, 157, 255, 0.16);

  &.is-weight {
    background: #25c59a;
    box-shadow: 0 1px 2px rgba(37, 197, 154, 0.16);
  }

  &.high {
    background: #e6a23c;
    box-shadow: 0 1px 2px rgba(230, 162, 60, 0.16);
  }

  &.over {
    background: #f56c6c;
    box-shadow: 0 1px 2px rgba(245, 108, 108, 0.16);
  }
}

.edit-container-goods-container__gauge-scale {
  position: absolute;
  left: 0;
  right: 0;
  top: 10px;
  height: 12px;
}

.edit-container-goods-container__gauge-mark {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  font-size: 9px;
  color: #98a2b3;
  min-width: max-content;
  line-height: 12px;

  &:last-child {
    transform: translateX(-100%);
  }
}

.mt-3 {
  margin-top: 0;
}

@media (max-width: 520px) {
  .edit-container-goods-container__gauges {
    grid-template-columns: 1fr;
  }
}

.edit-container-goods-container__booked-tag {
  font-size: 10px;
  color: #e6a23c;
  background: #fdf6ec;
  border: 1px solid #f5dab1;
  border-radius: 10px;
  padding: 1px 8px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-weight: 500;
}

.edit-container-goods-container__action--more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
</style>
